export const en = {
  organizations: 'organizations',
  organization_table: 'organizations table',
  number_of_influencers: 'no. of influencers',
  industry: 'industry',
  number_of_entities: 'no. of entities',
  number_of_new_sources: 'no. of news sources',
  mother_organization: 'mother organization',
  organization_details: 'organization details',
  partnership_info: 'partnership info',
  in_part_with: 'in partnership with',
  founded_on: 'founded on',
  general_info: 'general information',
  origin: 'origin',
  creation_info: 'creation info',
  branches: 'branches',
  add_new_organization: 'add new organization',
  about: 'about',
  select_inf: 'Please select the main orgazniation to grab data from',
  origin_country: 'origin country',
  search_by_branches: 'search by branches',
  search_by_organization: 'search by organization',
  industry_specialization: 'Industry Specialization',
  organization_name: 'organization name',
  add_another_Partnership_section: 'Add another Partnership section',
  from: 'from',
  to: 'to',
  partnership: 'partnership',
  date: 'date',
  description: 'description',
  related_organizations: 'related organizations',
  related_news_sources: 'related news sources',
  related_entities: 'related entities',
  related_influencers: 'related influencers',
  search_sources: 'search source',
  search_organization: 'search organization',
  sub_organizations: 'sub organizations',
  news_sources: 'news sources',
  entity_name: 'entity name',
  influencer_name: 'influencer name',
  source_name: 'source name',
  total_entities: 'total entities',
  total_influencers: 'total influencers',
  total_sources: 'total sources',
  total_partnerships: 'total partnerships',
  total_sub_organizations: 'total sub-organizations',
  total_related_organizations: 'total related-organizations',
  are_you_sure_you_want_to_cancel_edit_organization:
    'Are you sure you want to cancel editing organization?',
  are_you_sure_you_want_to_cancel_add_organization:
    'Are you sure you want to cancel adding influencer?',
  added_successfully: 'organization Added Successfully',
  edited_successfully: 'organization Edited Successfully',
  edit_organization: 'edit organization',
  created_organizations: 'created organizations',
  news_sources_count: 'news sources count',
  number_of_entities: 'no. of entities',
  number_of_influencers: 'no. of influencers',
  activity: 'Activity',
  activity_specialization: 'Activity Specialization',
  entities: 'entities',
  influencers: 'influencers',
  divisions: 'divisions',
  division_name: 'Division Name',
  divisions_total: 'Total Divisions',
  division: 'Division',
  division_search: 'Search by Division',
  delete_division:
    'Are you Sure you want to delete  this Division permanently ?',
  delete_division_success: 'Division has been removed successfully',
  tagline: 'tagline',
  company_type: 'company type',
  company_size: 'company size',
  office_address: 'office address',
  add_speciality: 'Add a speciality',
  specialties: 'specialties',
  specialty: 'specialty',
  total_jobs: 'total jobs',
  relations_type: 'relations type',
  organization_entity: 'organization entity',
};

export const ar = {
  organization_entity: ' كيان المؤسسه',
  relations_type: 'نوع العلاقات',
  total_jobs: 'إجمالي الوظائف',
  specialty: 'التخصص',
  specialties: 'التخصصات',
  add_speciality: 'إضافة التخصص',
  office_address: 'عنوان المكتب',
  tagline: 'الشعار',
  company_size: 'حجم المؤسسه',

  company_type: 'نوع المؤسسة',
  division_search: 'بحث بالشعبه',
  delete_division_success: 'تم مسح الشعب بنجاح',
  delete_division: 'هل انت متاكد انك تريد مسح هذا الشعبه نهائيا',
  division: 'الشعبه',
  divisions_total: 'إجمالي الشُعب',
  division_name: 'اسم الشعبه',
  divisions: 'الشُعب',
  entities: 'الكيانات',
  influencers: 'المؤثرون',
  organizations: 'المؤسسات',
  add_another_Partnership_section: 'إضافة قسم شراكة آخر',
  search_sources: 'بحث بإسم المصدر',
  search_organization: 'بحث بإسم المؤسسة',
  related_organizations: 'المؤسسات ذات صلة',
  related_news_sources: 'مصادر الاخبار ذات صلة',
  related_entities: 'الكيانات ذات صلة',
  related_influencers: 'المؤثرون ذات صلة',
  description: 'الوصف',
  from: 'من',
  to: 'إلى',
  partnership: 'الشراكه',
  date: 'التاريخ',
  origin_country: 'دوله المنشأ',
  search_by_branches: 'بحث بواسطة الفرع',
  search_by_organization: 'بحث بواسطة المؤسسة',
  industry_specialization: 'تخصص الصناعة',
  organization_name: 'اسم المؤسسة',
  organization_table: 'جدول المؤسسات',
  number_of_influencers: 'عدد المؤثرين',
  industry: 'الصناعة',
  number_of_entities: 'عدد الكيانات',
  number_of_new_sources: 'عدد المصادر الأخبارية',
  mother_organization: 'المؤسسة الام',
  organization_details: 'تفاصيل المؤسسة',
  partnership_info: 'بيانات الشراكة',
  in_part_with: 'في شراكة مع',
  founded_on: 'أنشأت في',
  origin: 'الأساس',
  mother_organization: 'المؤسسة الام',
  created_info: 'معلومات الإنشاء',
  branches: 'الفروع',
  general_info: 'بيانات عامة',
  add_new_organization: 'إضافة مؤسسه جديده',
  about: 'عن',
  select_inf: 'قم بأختيار المنظمة الاساسية لجلب البيانات',
  sub_organizations: 'المؤسسات الفرعية',
  news_sources: 'مصادر الاخبار',
  entity_name: 'اسم الكيان',
  influencer_name: 'اسم المؤثر',
  source_name: 'اسم المصدر',
  total_entities: 'إجمالي الكيانات',
  total_influencers: 'إجمالي المؤثرين',
  total_sources: 'إجمالي المصادر',
  total_partnerships: 'إجمالي الشراكة ',
  total_sub_organizations: 'إجمالي المؤسسات الفرعية',
  total_related_organizations: 'إجمالي المؤسسات ذات صلة',
  are_you_sure_you_want_to_cancel_edit_organization:
    'هل انت متأكد انك تريد الغاء تعديل  المؤسسة',
  are_you_sure_you_want_to_cancel_add_organization:
    'هل انت متأكد انك تريد الغاء إضافة  المؤسسة',
  added_successfully: 'تم إضافة المؤسسة بنجاح',
  edited_successfully: 'تم تعديل المؤسسة بنجاح',
  creation_info: 'معلومات الإنشاء',
  edit_organization: 'تعديل المؤسسة',
  created_organizations: 'المؤسسات المُنشأه',
  news_sources_count: 'عدد مصادر الاخبار',
  number_of_entities: 'عدد الكيانات',
  number_of_influencers: 'عدد المؤثرين',
  activity: 'نشاط',
  activity_specialization: 'تخصص النشاط',
};
